<script lang="ts" setup>
  import { useBreakpoints, type SaleOfferMessage } from '@storefront/storefront';
  import type { PropType } from 'vue';
  import type { ListOfferQuotationResource } from '@storefront/resources';

  const breakpoints = useBreakpoints();

  defineProps({
    offer: { type: Object, required: true },
    messages: { type: Array as PropType<SaleOfferMessage[]>, required: true },
    quotations: { type: Array as PropType<ListOfferQuotationResource[]>, required: true },
  });
</script>
<template>
  <div class="offer">
    <SfTile large>
      <template #title>
        <div class="offer__header">
          <h1 v-if="breakpoints.lg" class="offer__heading">
            {{ $t('SHOP.OFFER.HEADER.SALE_OFFER_NUMBER', { number: offer.id }) }}
          </h1>
          <div class="offer__date">
            {{ $t('SHOP.OFFER.LABEL.SALE_OFFER_DATE') }}
            <SfDateTime :value="offer.createdAt" time />
          </div>
        </div>
      </template>
      <template #headerAction>
        <div class="offer__status">
          <SfOfferStatus :status="offer.status" />
        </div>
      </template>
    </SfTile>
    <div class="offer__details">
      <OfferChat :messages="messages" :offer="offer" />
      <template v-if="quotations.length > 0">
        <OfferQuotations :offer="offer" :quotations="quotations" />
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .offer {
    display: flex;
    flex-direction: column;
    gap: 2rem;

    &__header {
      display: flex;
      flex-direction: column;
    }

    &__date {
      font-size: 0.875rem;
      color: var(--sf-account-color-dark-grey);
      font-weight: var(--font-weight-semi);
    }

    &__status {
      font-weight: var(--font-weight-semi);
      margin-left: 0.375rem;
    }

    &__details {
      display: flex;
      flex-direction: row;
      gap: 2rem;
      width: 100%;

      @include media.query(md) {
        flex-direction: column;
      }
    }
  }
</style>
